import type {ReactAction} from '@netx/core/bootstrap';
import {performAction} from '@netx/core/lib/utils';
import {faProjectDiagram} from '@fortawesome/pro-solid-svg-icons';
import {canManageAttributeProfiles} from '../enablers';
import {AttributeProfilesSystemLabel} from '../locales';

export const attributeProfileActionProfilesSystemRouteIcon = faProjectDiagram;

/**
 * Route to attribute profiles system
 * @param params
 * @returns Action
 */
export const attributeProfileActionProfilesSystemRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'attribute-profiles-system-route',
	cb: () => performAction('system:attributes:attributeProfiles:route'),
	enableTest: () => canManageAttributeProfiles(),
	icon: attributeProfileActionProfilesSystemRouteIcon,
	label: AttributeProfilesSystemLabel.ROUTE,
	routeMatch: /^system\/attribute\/attributeProfiles/,
	...params,
});
